// material-ui
import { Box, LinearProgress, LinearProgressProps, Typography } from '@mui/material';

// ==============================|| PROGRESS - LINEAR WITH LABEL ||============================== //
interface LinearWithLabelProps extends LinearProgressProps {
  useCompactViewStyle?: boolean;
}
export default function LinearWithLabel({ value, useCompactViewStyle, ...others }: LinearWithLabelProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" value={Math.min(value ?? 0, 100)} {...others} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: useCompactViewStyle ? '11px' : '13px' }}
        >{`${Math.round(value!)}%`}</Typography>
      </Box>
    </Box>
  );
}
